import { Paths, SecondaryPaths } from '../types/common';

export function getVideoItemPath(id: string): string {
  return `${Paths.VIDEO}/${id}`;
}

export function getPlaylistItemPath(id: string): string {
  return `${Paths.PLAYLIST}/${id}`;
}

export function getStudentPlaylistPath(id: string): string {
  return `${Paths.PLAYLISTS}/${id}`;
}

export function getStudentPlaylistItemPath(
  id: string,
  index: number
): string {
  return `${getStudentPlaylistPath(id)}/items/${index}`;
}

export function getPlayCoursePath(id: string): string {
  return `${Paths.PLAYCOURSE}/${id}`;
}

export function getPlayCourseAdminPath(id: string): string {
  return `${Paths.PLAYCOURSE_ADMIN}/${id}`;
}

export function getPlayCourseModulesPath(id: string): string {
  return `${getPlayCoursePath(id)}/modules`;
}

export function getPlayCourseModulePath(
  id: string,
  moduleKey: string
): string {
  return `${getPlayCourseModulesPath(id)}/${encodeURIComponent(moduleKey)}`;
}

export function getPlayCourseTopicPath(
  id: string,
  moduleKey: string,
  topicKey: string
): string {
  return `${getPlayCourseModulePath(id, moduleKey)}/topics/${encodeURIComponent(
    topicKey
  )}`;
}

export function getPlayCourseLessonPath(
  id: string,
  moduleKey: string,
  topicKey: string,
  lessonKey: string
): string {
  return `${getPlayCourseTopicPath(
    id,
    moduleKey,
    topicKey
  )}/lessons/${encodeURIComponent(lessonKey)}`;
}

export function getPlayCourseFilePath(
  id: string,
  moduleKey: string,
  topicKey: string,
  lessonKey: string,
  index: number
): string {
  return `${getPlayCourseLessonPath(
    id,
    moduleKey,
    topicKey,
    lessonKey
  )}/files/${index}`;
}

export function getPlayCourseSubtopicPath(
  id: string,
  moduleKey: string,
  topicKey: string,
  lessonKey: string,
  subtopicKey: string
): string {
  return `${getPlayCourseLessonPath(
    id,
    moduleKey,
    topicKey,
    lessonKey
  )}/subtopics/${encodeURIComponent(subtopicKey)}`;
}

export function getPlayCourseSubtopicFilePath(
  id: string,
  moduleKey: string,
  topicKey: string,
  lessonKey: string,
  subtopicKey: string,
  index: number
): string {
  return `${getPlayCourseSubtopicPath(
    id,
    moduleKey,
    topicKey,
    lessonKey,
    subtopicKey
  )}/files/${index}`;
}

export function getPlayCourseItemPath(id: string, index: number): string {
  return `${getPlayCoursePath(id)}/items/${index}`;
}

export function getEditVideoPath(id: string): string {
  return getVideoItemPath(id) + '/edit';
}

export function getVideoActionPagePath(id: string): string {
  return getVideoItemPath(id) + '/actions';
}

export function getPlayerLink(videoId: string): string {
  const hostname = window.location.hostname;
  
  // Default to production
  let host = 'https://edu.qblocks.ai/';

  // Runtime detection for specific environments
  if (hostname.includes('dev-edu-cabinet.qblocks.ai')) {
    host = 'https://dev-edu.qblocks.ai/';
  } else if (hostname.includes('edu-cabinet.qblocks.ai')) {
    host = 'https://edu.qblocks.ai/';
  } else if (process.env.PLAYER_HOST) {
    // Fallback to build-time env if provided
    host = process.env.PLAYER_HOST;
  }

  // Ensure host ends with a slash for consistent joining
  const finalHost = host.endsWith('/') ? host : `${host}/`;
  return `${finalHost}${videoId}`;
}

export function getCreateLinkPath(id: string): string {
  return getVideoItemPath(id) + SecondaryPaths.CREATE_LINK;
}

export function getPlayerEditLinkPath(videoId: string, linkId: string): string {
  return getVideoItemPath(videoId) + SecondaryPaths.EDIT_LINK + `/${linkId}`;
}

export function getVideoLinkStatisticPath(
  videoId: string,
  linkId: string,
  userId?: string
): string {
  if (userId) {
    return (
      getVideoItemPath(videoId) +
      SecondaryPaths.STATISTICS +
      `/${linkId}` +
      `?userId=${userId}`
    );
  }
  return getVideoItemPath(videoId) + SecondaryPaths.STATISTICS + `/${linkId}`;
}
